import state from './state'
import getters from './getters'
import mutations from './mutations'

import modulePasswordChange from './passwordChange'
import moduleUserInfo from './userInfo'
import moduleDataInit from './dataInit'
import moduleSiteConfig from './siteConfig'
import moduleApiTest from './apiTest'

export default {
  namespaced: true,
  state,
  getters,
  mutations,

  modules: {
    passwordChange: modulePasswordChange,
    userInfo: moduleUserInfo,
    dataInit: moduleDataInit,
    siteConfig: moduleSiteConfig,
    apiTest: moduleApiTest
  }
}
